import {errorToString} from "../utils";
import {httpServerHost} from "./server-hosts";

type RequestArgs =
  | [method: "GET", path: string]
  | [method: "POST" | "DELETE", path: string, body?: unknown];

export const request = async <T>(...[method, path, body]: RequestArgs) => {
  const response = await fetch(`${httpServerHost}${path}`, {
    method,
    mode: "cors",
    credentials: "include",
    headers: body ? {"Content-Type": "application/json"} : {},
    // RequestArgs rules out a body for GET, which this syntax-only rule can't see
    // eslint-disable-next-line unicorn/no-invalid-fetch-options
    body: body ? JSON.stringify(body) : undefined,
  });
  if (response.status >= 400) {
    if (response.headers.get("Content-Type")?.includes("application/json")) {
      const errorBody = (await response.json()) as unknown;
      throw new Error(errorToString(errorBody));
    } else {
      const errorText = await response.text();
      throw new Error(errorText);
    }
  }
  return response.json() as Promise<T>;
};
